import { render, staticRenderFns } from "./RequestMgtIntegration.vue?vue&type=template&id=5ff3ac76&scoped=true&"
import script from "./RequestMgtIntegration.vue?vue&type=script&lang=js&"
export * from "./RequestMgtIntegration.vue?vue&type=script&lang=js&"
import style0 from "./RequestMgtIntegration.vue?vue&type=style&index=0&id=5ff3ac76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff3ac76",
  null
  
)

export default component.exports
import {QBtn,QTr,QTd} from 'quasar'
component.options.components = Object.assign({QBtn,QTr,QTd}, component.options.components || {})
